// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"AddressPoint-69e2b24d-scss","ic-map":"AddressPoint-ee773be1-scss"};